import { Dispatch } from 'redux';
import { fetchProducerInfoFromEmail, setApiToken } from '../api';
import { reportToSentry } from '../helpers/sentry';
import { setIsMDA } from './agent';
import { setAgentProducerExternalId } from './agent';
import { clearApplication, fatalError, setPartnerInfo } from './application';
import { getMDAEmailFromParams } from '../helpers/getMDAEmailFromParams';
import * as Sentry from '@sentry/react';
import LogRocket from 'logrocket';

const handleMDAInbound = async (dispatch: Dispatch, getState: () => ReduxState) => {
  try {
    LogRocket.track('mda_inbound', { params: getState().location.search });
    const { location } = getState();
    dispatch(clearApplication());
    const mdaLocation = location.type === 'MDA_INBOUND' ? location : (location.prev as LocationState);
    const paramsString = mdaLocation.search ?? '';
    const email = getMDAEmailFromParams(paramsString);
    if (!email) return;
    Sentry.setExtra('mda_email', email);
    dispatch(clearApplication());
    dispatch(setIsMDA());

    const { data } = await fetchProducerInfoFromEmail(email);

    const decodedEmail = decodeURIComponent(email);
    Sentry.setUser({ id: data.producerExternalId, email: decodedEmail });
    LogRocket.identify(data.producerExternalId, {
      email: decodedEmail,
      agencyName: data.agencyName,
      agencyExternalId: data.agencyExternalId,
      channelPartnerId: data.channelPartnerId,
    });

    dispatch(setPartnerInfo(data));
    dispatch(setAgentProducerExternalId(data.producerExternalId));
    setApiToken(data.publishableKey);
  } catch (e) {
    reportToSentry(e as any);
    dispatch(fatalError(e));
  }
};

export default handleMDAInbound;
